export default {
    title: 'resend_sign_up_email_title',
    successfulResend: 'resend_sign_up_email_success',
    resendButton: 'resend_sign_up_email_resend',
};
